/**
 * React adapter over the pure `detectArtifact` classifier. Memoized on the
 * message content string so a re-render (or a streaming sibling message) never
 * re-runs detection for an unchanged message. Returns the detected artifact or
 * null. Kept tiny + separate from detect.ts so the classifier stays React-free
 * and unit-testable in isolation.
 */
import { useMemo } from 'react';
import { type Artifact, detectArtifact } from './detect';

export function useArtifact(content: string): Artifact | null {
  return useMemo(() => detectArtifact(content), [content]);
}
